import { ReactElement, PropsWithChildren, useContext } from 'react';

import { BackToHeaderContext } from '../../models/backToHeader';
import data from '../../models/data';

import BackButtonBar from './BackButtonBar';
import Header, { IProps as IHeaderProps } from './Header';

import './styles.scss';

interface IProps extends IHeaderProps {
  backButtonBarOnly?: boolean;
}

export function Headers({
  className = '',
  backButtonBarOnly = false,
  ...remainingProps
}: PropsWithChildren<IProps>): ReactElement {
  const { backToUrl } = useContext(BackToHeaderContext);

  const header = <Header {...remainingProps} />;

  return (
    <div className={`headers ${className}`}>
      {backToUrl && !data.isPfmClient && <BackButtonBar url={backToUrl} />}

      {!backButtonBarOnly && header}
    </div>
  );
}
